import Vue from "vue";
import {Toast} from "mint-ui";
import userModel from "../model/userModel"
import { parse } from "path";
import  axios  from "axios";
import qs from 'qs' ;
// const jsonp = require("jsonp");
export function netJson(url, param, success, fail) {
    Vue.http.options.emulateJSON = true;
    Vue
        .http
        .get(url, { params: param })
        .then(function(res) {
            success(res.body);
        }, fail);
}
export function netJsonp(url, param, success, fail) {
    Vue
        .http
        .jsonp(url, { params: param })
        .then(function(res) {
            success(res.body);
        }, fail);
}

export function netOldJsonp(url, param, success, fail) {
    Vue
        .http
        .jsonp(url, { params: param, jsonpCallback: "callFun" })
        .then(function(res) {

            success(res.body);
        }, fail);
}
export function netOldJsonp1(url, param, success, fail) {
    Vue
        .http
        .jsonp(url, { params: param, jsonpCallback: "callFun1" })
        .then(function(res) {

            success(res.body);
        }, fail);
}
export function netTradeJsonp(url, param, success, fail) {
    Vue
        .http
        .jsonp(url, { params: param, jsonp: "callbackParam" })
        .then(function(res) {

            success(res.body);
        }, fail);
}

export function netOldJsonpWithHeader(url, header, param, success, fail) {

    Vue
        .http
        .jsonp(url, { params: param, jsonpCallback: "callFun", headers: header })
        .then(function(res) {
            success(res.body);
        }, fail);
}

// export function jsonp1(url, param, success, fail) {
//     url += "?";
//     for (let key in param) {
//         url += key + "=" + param[key] + "&";
//     }
//     jsonp(url, null, function(err, data) {
//         if (err) {
//             fail(err.message);
//         } else {
//             success(data);
//         }
//     });
// }

export function netPost(url, param, success, fail) {
    Vue.http.post(
            url,
            param,
             {
             emulateJSON:true,
            }
        )
        .then(function(res) {
            
            if(res.body==""||res.body==null||typeof res.body=="undefined"){
                res.body=eval( "(" + res.bodyText.replace(/(\s\s+)/g,"") + ")");
            }
            const href=window.location.href.split("/#/")[1];
            if(res.body&&res.body.errorMsg&&res.body.errorMsg.indexOf("非法登录")>-1){
                Toast("您的账号已在其它客户端登录，如非本人操作，则可能密码已泄露，建议及时修改密码");
                userModel.clear();
                setTimeout(() => {
                    window.location.href=window.location.origin+"/#/login?backUrl="+encodeURIComponent(href);
                   // window.open(window.location.origin+"/#/login", '_top')
                }, 1500);
            }else if(res.body&&res.body.errorMsg&&res.body.errorMsg.indexOf("超时")>-1){
                Toast("登录超时，请重新登录");
                userModel.clear();
                setTimeout(() => {
                    window.location.href=window.location.origin+"/#/login?backUrl="+encodeURIComponent(href);
                   // window.open(window.location.origin+"/#/login", '_top')
                }, 1500);
            }else{
                success(res.body);
            }
        }, fail);
}

export function netNormalPost(url, data, success, fail) {
    data=qs.stringify(data);
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    };
    axios.post(
            url,
            data,
            headers
        )
        .then(function(res) {
            success(res.data);
        }, fail);
}
export function netNormalJsonPost(url, data, success, fail) {
    axios.defaults.headers.common['Authorization'] = "bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhY2NvdW50IjoiMTg4MTQ4NjIyMTEiLCJ1c2VySWQiOjIxfQ.JBsEauk4J6GJg8LMufsne0EL8uyvvs3mBdjeYrPuS5Y";
    axios.post(
            url,
            data,
            
        )
        .then(function(res) {
            success(res.data);
        }, fail);
}


// WEBPACK FOOTER //
// ./src/network/baseNet.js